import { Container, Row, Col, Button } from 'reactstrap';
import {
  useTranslator,
  useAppContext,
  withMobileAppMode,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';

const TrackerNoAccess = ({ mobileAppMode }) => {
  const { t, language } = useTranslator();
  const {
    images: { unauthorized },
    consts: { APP_BRAND },
  } = useAppContext();

  const aiAccess = sessionStorage.getItem('aiAccess');
  const dietAccess = sessionStorage.getItem('dietAccess');
  const workoutAccess = sessionStorage.getItem('workoutAccess');

  let landingPageUrl = import.meta.env.VITE_LANDING_PAGE_URL;

  if (APP_BRAND === 'dtba') {
    if (language === 'pl-PL') {
      if (!dietAccess || !workoutAccess) {
        landingPageUrl = 'https://dieta.hpba.pl/';
      } else if (!aiAccess) {
        landingPageUrl = 'https://dieta.hpba.pl/ai/';
      }
    } else {
      landingPageUrl = 'https://dieta.hpba.pl/en/';
    }
  }

  const handleClick = () => {
    callNativeMobileApp({
      action: 'open_modal',
      payload: {
        target: 'price_list',
      },
    });
  };

  const handleRefresh = () => {
    localStorage.removeItem('apollo-cache-persist');
    window.location.reload();
  };

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('access.navbarTitle')}</TitleBar>
      <div className="page-template-other full-height3a">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div
                  className={
                    mobileAppMode
                      ? 'other-container text-center d-flex align-items-center min-height'
                      : 'other-container text-center'
                  }
                >
                  <Row>
                    <Col xl={{ size: 6, offset: 3 }}>
                      <img src={unauthorized} className="img-fluid mb-xl" alt="" />
                      <h2 className="title-medium semi-bold">{t('noAccess.title')}</h2>
                      <p className="mb-xl text-text-variant-color">{t('app.noAccess.content')}</p>

                      {mobileAppMode ? (
                        <>
                          <Button color="primary" className="w-100" onClick={() => handleClick()}>
                            {t('noAccess.buyAccess.button')}
                          </Button>

                          <Button
                            color="secondary"
                            outline
                            className="w-100 mt-3"
                            onClick={handleRefresh}
                          >
                            {t('accessUnauthorizedException.refresh.button')}
                          </Button>
                        </>
                      ) : (
                        <>
                          <a className="btn btn-primary w-100" href={landingPageUrl}>
                            {t('noAccess.buyAccess.button')}
                          </a>
                          <Button
                            color="secondary"
                            outline
                            className="w-100 mt-3"
                            onClick={handleRefresh}
                          >
                            {t('accessUnauthorizedException.refresh.button')}
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default withMobileAppMode(TrackerNoAccess);
